const PageData = [
    {
        name: 'about',
        title: 'About',
        path: '/',
        color: 'bg-orange',
        subtitle: 'It\u2019s my goal to make every project fresh and unique.',
        body: ['I am a full-stack web engineer and UI designer with over 20 years of professional experience. I am an expert in desktop and mobile website development, graphic design, search engine optimization, and accessibility. With a wide range of skills, I create new and interesting ways to improve the user\u2019s experience.',' I take great pride in my work and adapt to an ever-changing industry to provide solutions to complex design challenges. My perfectionist eye for detail ensures a high standard of quality throughout the entire process.'],  
        media: [
            {
                url:'/media/portrait-min2.jpg',
                title: 'David Rankin'
            },
            {
                url:'/media/portrait-min.jpg',
                title: 'David Rankin'
            },
        ],
        resume_url: '/David-Rankin-Resume.pdf',
        weight: 0,
    },
    {
        name: 'portfolio',
        title: 'Portfolio',
        path: '/portfolio/websites',
        color: 'bg-green',
        body: '',  
        weight: 1,
    },
    {
        name: 'skills',
        title: 'Skills',
        path: '/skills',
        color: 'bg-blue',
        body: '',
        weight: 2,
    },
]

export default PageData;